export const isNumeric = (value: string) => {
  return (value.match(/^[0-9.]+$/i) && !Number.isInteger(+value)) || 'value is not Numeric';
};